import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSignup } from "../hook/useSignup.mjs";
import GoogleSignInButton from "../../../components/GoogleSignInButton.mjs";
import EnvironmentCard from "../../../components/EnvironmentCard.mjs";
import { AuthContext } from "../../../authProvider.mjs";
import PageShell from "../../../components/PageShell.mjs";


export const SignupPage = () => {
    const {
        region,
        setRegion: _setRegion,
    } = useSignup();

    const navigate = useNavigate();
    const [oauthError, setOauthError] = useState('');
    const { setAuthenticatedUser, refreshAuthState } = useContext(AuthContext);


    const handleOAuthSuccess = async (user) => {
        setAuthenticatedUser(user);
        await refreshAuthState();
        navigate('/');
    };

    const handleOAuthError = (message) => {
        setOauthError(message);
    };

    return (
        <PageShell variant="entry">
            <div className="bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl p-6 sm:p-8 w-full max-w-md border border-white/20 relative overflow-hidden">
                {/* Decorative accent */}
                <div className="absolute top-0 left-0 right-0 h-1 bg-stanford-red"></div>

                <h2 className="text-2xl font-bold text-center mb-6 text-stanford-red">
                    Create an Account
                </h2>

                {/* OAuth Error Message */}
                {oauthError && (
                    <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm mb-4">
                        {oauthError}
                    </div>
                )}

                {/* Environment selector: here only while in Test, so anyone the test
                    backend refuses can get back to Production. Admins pick Test
                    from the home page. */}
                <EnvironmentCard />

                {/* Google Sign In */}
                <div className="mb-6">
                    <GoogleSignInButton
                        onSuccess={handleOAuthSuccess}
                        onError={handleOAuthError}
                        selectedRegion={region}
                    />
                </div>

                {/* DISABLED: email signup form removed - Google sign-in is the only registration method */}
                {/*
                <div className="relative mb-6">
                    <div className="absolute inset-0 flex items-center">
                        <div className="w-full border-t border-gray-300"></div>
                    </div>
                    <div className="relative flex justify-center text-sm">
                        <span className="px-4 bg-white text-gray-500">or sign up with email</span>
                    </div>
                </div>

                <form className="space-y-4" onSubmit={handleSubmitSignup}>
                    ... email signup form ...
                </form>
                */}

                <div className="pt-4 text-center text-sm text-gray-600">
                    <p>Already have an account? <Link to="/login" className="inline-block py-3 sm:py-0 text-stanford-red hover:text-stanford-light-red font-medium">Login here</Link></p>
                </div>
            </div>
        </PageShell>
    );
};
